import React  from 'react';
import Classes from "classnames";

export default function renderTextGroupListHeader(id, props) {
    const { data, className } = props;

    const classes = Classes(className, 'gd-field-string-group-list-header');

    return (
        <div className={classes}>
            <div className="group-list-header-value">{data.value ? data.value : "Not set"}</div>
        </div>
    );
}